import { Injectable } from '@angular/core';
import { AuthEvents } from '@ponder-core/auth/auth.events';
import { UIEvents } from './ui.events';
import { CollectionEvents } from './collection.events';
import { DeckEvents } from './deck.events';
import { ProfileEvents } from './profile.events';
import { AdminEvents } from './admin.events';
import { StatsEvents } from './stats.events';
import { AccountEvents } from './account.events';

/**
 * The generic message/event broker for the Ponder ecosystem.
 * This is used for pushing data/events out, which is then received by subscribed listeners.
 */
@Injectable({ providedIn: 'root' })
export class EventBroker {
    public admin: AdminEvents = new AdminEvents();
    public auth: AuthEvents = new AuthEvents();
    public collection: CollectionEvents = new CollectionEvents();
    public deck: DeckEvents = new DeckEvents();
    public profile: ProfileEvents = new ProfileEvents();
    public ui: UIEvents = new UIEvents();
    public account: AccountEvents = new AccountEvents();
    public stats: StatsEvents = new StatsEvents();
}